import { z } from 'zod';

export const refSchema = z.object({
  /** a short ref such as #12345 */
  short: z.string().trim(),
  /** a main ref is longer such as timestamps or anything such as #AA10345678912 */
  main: z.string().trim(),

  /**
   * this cloud be any id set by any type of user we have in the system.
   *
   * #b-123 this cloud be generated by the business either manually or when we integrate with their system such as SAP. This ref does not effect us. it's just for the business to match ref numbers with us
   *
   * or #c-123 for carriers. or any id the user want add as string
   *
   */
  custom: z.string().optional(),
});
export type Ref = z.infer<typeof refSchema>;
